import api from '@/apis/di/dictionaryOptionAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('dictionaryOption', api);

const state = {
  ...crud.state,
  _config: {
    table: 'dictionary_option',
    field: {
      key: 'dictionary_option_id',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,

  /**
   * Load list danh mục
   */
  async loadDictionaryOption(context, payload) {
    let res = null;

    try {
      context.commit('updateLoading', true);
      res = await api.getDictionaryOptionUser();
    } finally {
      context.commit('updateLoading', false);
    }

    if (res) {
      context.commit('setItems', res);
    }

    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
